import { Record } from 'immutable';
import Hydrator from 'utils/Hydrator';
import DeltaValue from './DeltaValueModel';

const DeltaRecord = Record({
  status: '',
  period: {},
  values: [],
});

export default class Delta extends DeltaRecord {
  static deserialize(jsonObject = {}) {
    const mapProperties = {
      values: Hydrator.fromArray(DeltaValue.deserialize),
    };

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new Delta(hydrated);
  }

  getDeltaValue(type) {
    return this.values?.find((value) => value.type === type);
  }
}
